import { ams } from './ams';
import { bergamos } from './bergamos';
import { demo } from './demo';
import { dhi } from './dhi';
import { hairscalp } from './hairscalp';
import { hrimn } from './hrimn';
import { khc } from './khc';
import { kvcm } from './kvcm';
import { riviera } from './riviera';
import { sbl } from './sbl';

/**
 * Per-client bundles are not identical in TypeScript (different optional sections, etc.),
 * but at runtime we only need a shared loose shape. `any` here is intentional until a
 * generated or hand-maintained union type exists for all clients.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const clients: { [key: string]: any } = {
  ams,
  bergamos,
  demo,
  dhi,
  hrimn,
  sbl,
  kvcm,
  hairscalp,
  khc,
  riviera
};

const DEFAULT_CLIENT = 'demo';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const config: any = clients[process.env.CLIENT_NAME || DEFAULT_CLIENT];

export default config;
